@file:OptIn(InternalResourceApi::class)

package resume.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/resume.app.shared.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(514_707_430)
internal val Res.drawable.ic_github: DrawableResource by lazy {
      DrawableResource("drawable:ic_github", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_579_832_383)
internal val Res.drawable.ic_mail: DrawableResource by lazy {
      DrawableResource("drawable:ic_mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_mail.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_598_885_068)
internal val Res.drawable.ic_moon: DrawableResource by lazy {
      DrawableResource("drawable:ic_moon", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_moon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_839_312_109)
internal val Res.drawable.ic_phone: DrawableResource by lazy {
      DrawableResource("drawable:ic_phone", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_phone.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_351_157_503)
internal val Res.drawable.ic_sun: DrawableResource by lazy {
      DrawableResource("drawable:ic_sun", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_sun.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_714_468_621)
internal val Res.drawable.image_zaur: DrawableResource by lazy {
      DrawableResource("drawable:image_zaur", setOf(
        ResourceItem(setOf(), "${MD}drawable/image_zaur.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_github", Res.drawable.ic_github)
  map.put("ic_mail", Res.drawable.ic_mail)
  map.put("ic_moon", Res.drawable.ic_moon)
  map.put("ic_phone", Res.drawable.ic_phone)
  map.put("ic_sun", Res.drawable.ic_sun)
  map.put("image_zaur", Res.drawable.image_zaur)
}
